import type { VerifyEmailErrorReasons } from '@hotjar/webapp/domains/common/verify-email/model';

export const ERROR_MESSAGES: Record<VerifyEmailErrorReasons, string> = {
  too_many_tokens: 'account-email.form.error.too-many-tokens',
  email_exists: 'account-email.form.error.email-exists',
  email_restricted: 'account-email.form.error.email-restricted',
  missing_email_name: 'account-email.form.error.missing-email-name',
  unhandled: 'account-email.form.error.unhandled',
  '10 per 10 minute': 'account-email.form.error.too-many-requests',
};
